import App from './App.vue';

export default {
  path: '/CDS_VF_No4_2Detail',
  name: 'CDS_VF_No4_2Detail',
  component: App,
  meta: {
    pageProperty: {
      title: '被害総括詳細',
      controller: 'CDS_CTR_No4_2Detail',
    },
  },
};
